import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { i18n } from 'src/i18n';
import authActions from 'src/modules/auth/authActions';
import authSelectors from 'src/modules/auth/authSelectors';
import layoutActions from 'src/modules/layout/layoutActions';
import { getHistory } from 'src/modules/store';
import I18nSelect from 'src/view/layout/I18nSelect';
import Avatar from 'src/view/shared/Avatar';
import config from 'src/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faBars,
  faLock,
  faMoon,
  faSignOutAlt,
  faThLarge,
  faCode,
  faUsers,
  faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';
import { Menu } from '@headlessui/react';
import layoutSelectors from 'src/modules/layout/layoutSelectors';
import DemoRedact from 'src/view/shared/DemoRedact';

function Header(props) {
  const dispatch = useDispatch();
  const location = useLocation();

  const doToggleMenu = () => {
    dispatch(layoutActions.doToggleMenu());
  };

  const darkMode = useSelector(
    layoutSelectors.selectDarkMode,
  );

  const userText = useSelector(
    authSelectors.selectCurrentUserNameOrEmailPrefix,
  );
  const userAvatar = useSelector(
    authSelectors.selectCurrentUserAvatar,
  );
  const currentTenant: any = useSelector(
    authSelectors.selectCurrentTenant,
  );

  const hasPermissions : boolean = currentTenant && currentTenant.permissions;
  const permissions = currentTenant.permissions;

  // Check if we're on a partner LeadsOnly management page
  const isOnPartnerLeadsOnlyPage = location.pathname.startsWith('/partner/leads-only-client');

  const doSignout = () => {
    dispatch(authActions.doSignout());
  };

  const doNavigateToProfile = () => {
    getHistory().push('/profile');
  };

  const doNavigateToPasswordChange = () => {
    getHistory().push('/password-change');
  };

  const doNavigateToTenants = () => {
    getHistory().push('/tenant');
  };

  const doNavigateToLeadsOnlyClients = () => {
    getHistory().push('/partner/leads-only-clients');
  };

  const doNavigateBackToDashboard = () => {
    getHistory().push('/');
  };

  return (
    <nav className="shadow bg-gray-800 text-white w-full">
      <div className="px-6 py-3">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-4">
            <div className="text-xl font-semibold md:hidden lg:hidden">
              <button
                className="focus:outline-none text-xl font-bold text-white hover:text-gray-300"
                onClick={doToggleMenu}
              >
                <FontAwesomeIcon icon={faBars} />
              </button>
            </div>

            <p className='text-lg lg:text-2xl font-bold text-white'><DemoRedact>{currentTenant.name}</DemoRedact></p>
          </div>

          <div className="flex items-center mt-0">
              {/* <div className="mr-6">
                <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                  <input
                    type="checkbox"
                    name="darkMode"
                    id="darkMode"
                    checked={darkMode}
                    onChange={(event) =>
                      dispatch(
                        layoutActions.doDarkModeChange(
                          event.target.checked,
                        ),
                      )
                    }
                    className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
                  />
                  <label
                    htmlFor="darkMode"
                    className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
                  ></label>
                </div>
                <label
                  htmlFor="darkMode"
                  className="text-xs text-gray-700 dark:text-white"
                >
                  <FontAwesomeIcon icon={faMoon} />
                </label>
              </div> */}
              {/* <div className="mr-6 md:block lg:block hidden">
                <I18nSelect />
              </div> */}

              <Menu>
                <Menu.Button className="flex items-center focus:outline-none">
                  <Avatar
                    size="small"
                    src={userAvatar || undefined}
                    alt="avatar"
                  />

                  <div className="text-left mx-2 text-sm font-medium text-gray-200 hidden md:block lg:block">
                    {userText}
                    {/* {[
                      'multi',
                      'multi-with-subdomain',
                    ].includes(config.tenantMode) && (
                      <div className="text-xs font-medium">
                        {currentTenant &&
                          currentTenant.name}
                      </div>
                    )} */}
                  </div>
                </Menu.Button>

                <Menu.Items>
                  <div className="absolute right-0 z-20 w-48 py-2 mt-2 rounded-md shadow-xl bg-gray-800">
                    <Menu.Item>
                      <button
                        onClick={doNavigateToProfile}
                        className="w-full text-left block px-4 py-2 text-sm capitalize transition-colors duration-200 transform text-gray-200 hover:bg-teal-600 hover:text-white"
                        type="button"
                      >
                        <FontAwesomeIcon
                          className="mr-2"
                          icon={faUser}
                        />
                        {i18n('auth.profile.title')}
                      </button>
                    </Menu.Item>
                    <Menu.Item>
                      <button
                        onClick={doNavigateToPasswordChange}
                        className="w-full text-left block px-4 py-2 text-sm capitalize transition-colors duration-200 transform text-gray-200 hover:bg-teal-600 hover:text-white"
                        type="button"
                      >
                        <FontAwesomeIcon
                          className="mr-2"
                          icon={faLock}
                        />
                        {i18n('auth.passwordChange.title')}
                      </button>
                    </Menu.Item>
                    {[
                      'multi',
                      'multi-with-subdomain',
                    ].includes(config.tenantMode) && (
                      <Menu.Item>
                        <button
                          onClick={doNavigateToTenants}
                          className="w-full text-left block px-4 py-2 text-sm capitalize transition-colors duration-200 transform text-gray-200 hover:bg-teal-600 hover:text-white"
                          type="button"
                        >
                          <FontAwesomeIcon
                            className="mr-2"
                            icon={faThLarge}
                          />
                          {i18n('auth.tenants')}
                        </button>
                      </Menu.Item>
                    )}
                    {hasPermissions && permissions.isPartner && (
                      isOnPartnerLeadsOnlyPage ? (
                        <Menu.Item>
                          <button
                            onClick={doNavigateBackToDashboard}
                            className="w-full text-left block px-4 py-2 text-sm capitalize transition-colors duration-200 transform text-gray-200 hover:bg-teal-600 hover:text-white"
                            type="button"
                          >
                            <FontAwesomeIcon
                              className="mr-2"
                              icon={faArrowLeft}
                            />
                            Back to Dashboard
                          </button>
                        </Menu.Item>
                      ) : (
                        <Menu.Item>
                          <button
                            onClick={doNavigateToLeadsOnlyClients}
                            className="w-full text-left block px-4 py-2 text-sm capitalize transition-colors duration-200 transform text-gray-200 hover:bg-teal-600 hover:text-white"
                            type="button"
                          >
                            <FontAwesomeIcon
                              className="mr-2"
                              icon={faUsers}
                            />
                            Leads-Only Clients
                          </button>
                        </Menu.Item>
                      )
                    )}
                    {config.apiDocumentationUrl && hasPermissions && permissions.isPartner && (
                      <Menu.Item>
                        <a
                          href={config.apiDocumentationUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-full text-left block px-4 py-2 text-sm capitalize transition-colors duration-200 transform text-gray-200 hover:bg-teal-600 hover:text-white"
                        >
                          <FontAwesomeIcon
                            className="mr-2"
                            icon={faCode}
                          />
                          {i18n('api.menu')}
                        </a>
                      </Menu.Item>
                    )}
                    <Menu.Item>
                      <button
                        onClick={doSignout}
                        className="w-full text-left block px-4 py-2 text-sm capitalize transition-colors duration-200 transform text-gray-200 hover:bg-teal-600 hover:text-white"
                        type="button"
                      >
                        <FontAwesomeIcon
                          className="mr-2"
                          icon={faSignOutAlt}
                        />
                        {i18n('auth.signout')}
                      </button>
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Menu>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;
